<form [formGroup]="form" (ngSubmit)="onSubmitForm()">
  <div class="form-group pt-2 selector-class">
    <label for="settings">
      {{ 'ActionLog::Event' | abpLocalization }}
    </label>
    <ng-select formControlName="settings" id="settings" [items]="items" bindLabel="labelKey" bindValue="key"
      [multiple]="true" [closeOnSelect]="false">
      <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
        <div class="d-flex align-items-center">
          <input id="item-{{ index }}" type="checkbox" [ngModel]="item$.selected"
            [ngModelOptions]="{ standalone: true }" />
          <span class="ps-1">
            {{ item.labelKey | abpLocalization }}
          </span>
        </div>
      </ng-template>
      <ng-template ng-label-tmp let-item="item">
        <span class="ng-value-icon left" aria-hidden="true" (click)="removeFromSelected(item.key)">
          ×
        </span>
        <span class="ng-value-label">
          {{ item.labelKey | abpLocalization }}
        </span>
      </ng-template>
    </ng-select>
  </div>

  <div class="form-group pt-2 selector-class">
    <label for="receiverType">
      {{ 'ActionLog::ReceiverType' | abpLocalization }}
    </label>
    <ng-select formControlName="receiverType" id="receiverType" [items]="receiverTypeItems" bindLabel="labelKey"
      bindValue="key" [clearable]="false">

      <ng-template ng-option-tmp let-item="item">
        <span>{{ item.labelKey | abpLocalization }}</span>
      </ng-template>

      <ng-template ng-label-tmp let-item="item">
        <span>{{ item.labelKey | abpLocalization }}</span>
      </ng-template>
    </ng-select>
  </div>

  <div class="form-group pt-2 selector-class">
    <label for="triggerEvent">
      {{ 'ActionLog::TriggerEvent' | abpLocalization }}
    </label>
    <ng-select formControlName="triggerEvent" id="triggerEvent" [items]="triggerEventItems" bindLabel="labelKey"
      bindValue="key" [clearable]="false">

      <ng-template ng-option-tmp let-item="item">
        <span>{{ item.labelKey | abpLocalization }}</span>
      </ng-template>

      <ng-template ng-label-tmp let-item="item">
        <span>{{ item.labelKey | abpLocalization }}</span>
      </ng-template>
    </ng-select>
  </div>

  <div class="form-group pt-2 selector-class">
    <input
      type="checkbox"
      id="migrateMaskedAudio"
      [(ngModel)]="migrateMaskedAudioCb"
      formControlName="migrateMaskedAudio"/>
      <label class="ps-1" for="migrateMaskedAudio">
      {{ 'ActionLog::MigrateMaskedAudio'  | abpLocalization }}
    </label>
  </div>

  <div class="form-group pt-2">
    <label for="maskedAudioExtension">{{ 'ActionLog::MaskedAudioExtension' | abpLocalization }}</label>
    <input
      type="text"
      class="form-control form-control-sm"
      id="maskedAudioExtension"
      formControlName="maskedAudioExtension"/>
  </div>

  <button type="submit" class="btn btn-primary mt-3">
    <i class="me-1 fas fa-save"></i>
    {{ 'AbpUi::Save' | abpLocalization }}
  </button>
</form>